module.exports = __webpack_public_path__ + "static/media/law_requirements.40eaadd3.png";